import React, { ReactElement, ElementType, PropsWithChildren } from 'react'
import { Flex } from 'theme-ui'
import { Svg } from 'ui'
import OrangeBlur from 'images/organization/features/malware/usecase-glow.svg'
import BlueBlur from 'images/integrations/blue-blur.svg'
import { TextWithBreakpointVariant } from 'ui/TextWithBreakpointVariant'

export function SectionContainer({
  sectionIcon,
  title,
  children,
  isOrangeBlur,
}: PropsWithChildren<{
  sectionIcon: ElementType
  title: string
  isOrangeBlur?: boolean
}>): ReactElement {
  return (
    <Flex
      sx={{
        width: '100%',
        px: ['1.6rem', '1.6rem', 0],
        flexDirection: 'column',
        textAlign: 'center',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'center',
          height: 'fit-content',
          mb: ['4rem', '9.8rem'],
        }}
      >
        <Flex
          sx={{
            position: 'relative',
            width: '8rem',
            height: '8rem',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Svg svg={sectionIcon} descriptiveText={`${title} section icon`} />
        </Flex>
        <TextWithBreakpointVariant
          variant={['size28Weight600', 'size40Weight600']}
          as="h2"
          sx={{
            maxWidth: '54rem',
            color: 'aliceBlue',
            mt: '1.6rem',
          }}
          tabIndex={0}
        >
          {title}
        </TextWithBreakpointVariant>
        <Svg
          svg={isOrangeBlur ? OrangeBlur : BlueBlur}
          sx={{ position: 'absolute', top: '-10rem', width: ['auto', 'auto'], zIndex: 'zIndex0' }}
          descriptiveText={`${
            isOrangeBlur ? 'Orange' : 'Blue'
          } decorative glow effect for ${title} section`}
        />
      </Flex>
      <Flex
        sx={{
          flexWrap: 'wrap',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '102.5rem',
          gap: ['2.4rem', '2.4rem', '3.2rem'],
          zIndex: 'zIndex1',
        }}
      >
        {children}
      </Flex>
    </Flex>
  )
}

export default SectionContainer
